<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout d-block>
            <v-flex v-if="listIsEmpty">
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>
            <v-flex v-for="file in listOfNestorFiles" v-bind:key="file.weekNumber">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                      large
                      block
                      v-on="on"
                      :href="renderUrl(file)"
                  >Week {{ file.weekNumber }} ({{ file.count }})
                  </v-btn>
                </template>
                <span>{{ renderDate(file.startDate) + " t/m " + renderDate(file.endDate) }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {dataSummaryService} from "@/services/admin";

export default {
  name: "nestorDownload",
  data: () => ({
    listOfNestorFiles: []
  }),
  computed: {
    listIsEmpty() {
      return this.listOfNestorFiles.length === 0;
    }
  },
  methods: {
    renderDate(ISODateString) {
      const date = new Date(ISODateString);
      return date.toLocaleDateString("nl-NL");
    },
    renderUrl(nestorFile) {
      return (
          "/api/v1/data/nestor/export?week=" +
          nestorFile.weekNumber +
          "&year=" +
          nestorFile.year
      );
    },
    populate() {
      dataSummaryService
          .resolveNestorSummary()
          .then(result => (this.listOfNestorFiles = result.data))
          // eslint-disable-next-line
          .catch(() => console.log("Error!"));
    }
  },
  created() {
    this.populate();
  }
};
</script>